import type { Hook } from 'phoenix_live_view';
import { pushPanelLoadEvent } from './push-panel-load';

/**
 * Pushes "load-feedback-stats" when the target game id is set or changes (e.g. switching
 * games while staying on Analysis). `mounted` alone misses LiveView patches that reuse the node.
 */
export const loadFeedbackStats: Hook = {
  mounted() {
    pushPanelLoadEvent(this, 'load-feedback-stats');
  },
  updated() {
    pushPanelLoadEvent(this, 'load-feedback-stats');
  },
};
